import { TokenApi } from './bootstrap/TokenApi';
import { Log } from '@lightningjs/sdk';
import { Backend } from './Backend';

export class UnauthorizedHandler {
  private _refreshRequest?: Promise<unknown> = undefined;

  handle(backend: Backend): Promise<unknown> {
    if (!this._refreshRequest) {
      this._requestNewToken(backend);
    }
    return this._refreshRequest!;
  }

  _requestNewToken(backend: Backend) {
    const token = TokenApi.load();
    if (!token || !token.refresh) {
      backend.goToLogin();
      return;
    }
    this._refreshRequest = TokenApi.refresh(backend, token.refresh.token)
      .then(refreshedToken => {
        if (refreshedToken.access?.token && refreshedToken.access.isValid()) {
          backend.token = refreshedToken;
          TokenApi.save(refreshedToken);
          return true;
        }
        return false;
      })
      .then(tokenRefreshed => {
        this._refreshRequest = undefined;
        return tokenRefreshed;
      })
      .catch(err => {
        Log.error('Could not refresh token, redirecting to login ', err);
        this._refreshRequest = undefined;
        backend.token = undefined;
        backend.goToLogin();
      });
  }
}
